export default "__VITE_ASSET__5b0d4216__"